import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"
import Helmet from "react-helmet"
import { navigate } from "gatsby-link"

import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import Section from "../../section/section"
import Accordion from "./accordion"

import { ContactWrapper, ContactWrapperAlt } from "./faqcontact.styled"

import { buildFAQPage } from "../../../../../utils/schemaHelper"

const launchZenDesk = () => {
  segmentEvent("Start Chat Clicked", {
    text: "Start Chat",
    type: "button",
  })
  if (
    typeof window !== `undefined` &&
    typeof window.$zopim !== `undefined` &&
    typeof window.$zopim.livechat !== `undefined` &&
    typeof window.$zopim.livechat.window !== `undefined` &&
    typeof window.$zopim.livechat.window.show !== `undefined`
  ) {
    // show chat window
    window.$zopim.livechat.window.show()
  } else if (!!window.adaEmbed) {
    window.adaEmbed.toggle()
  }
}

const FaqContact = ({ sku, data = {} }) => {
  const { accordions = [] } = data
  const className = sku || ""
  const label = "More about our Services"

  const handleClickService = () => {
    segmentEvent("Marketing CTA Clicked", {
      destination: "/service/",
      module_location: "bottom_fold",
      text: label,
      type: "link",
    })
    navigate("/service/")
  }

  const handleClickPhone = () => {
    segmentEvent("Marketing CTA Clicked", {
      destination: "tel:8884543320",
      module_location: "bottom_fold",
      text: "(888) 454-3320",
      type: "link",
    })
  }

  const handleClickEmail = () => {
    segmentEvent("Marketing CTA Clicked", {
      destination: "mailto:support@nutrafol.com",
      module_location: "bottom_fold",
      text: "support@nutrafol.com",
      type: "link",
    })
  }

  return (
    <Section className={className}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(buildFAQPage(accordions))}
        </script>
      </Helmet>

      <Flex flexWrap="wrap" className="md:gap-[40px] lg:gap-[80px]">
        <Box width={1} mb={[40, null, 24, 40, 0]}>
          <Accordion data={data} />
        </Box>
        <Flex flexWrap="wrap" mx={[0, 0, -12, -20]}>
          <Box
            width={[1, null, 1 / 2]}
            mb={[24, null, null, 40]}
            px={[0, 0, 12, 20]}
          >
            <ContactWrapper className="bg-nova-base-solid-20 text-center p-[32px] md:p-[40px]">
              <TextElementNova
                element="h3"
                text={`Have questions?`}
                className="Subtitle-20-Dia-Normal"
              />
              <TextElementNova
                element="p"
                text={`Chat with our customer support team. <br/>Monday - Friday ${process.env.GATSBY_CX_HOURS}`}
                className="Body-20-Dia-Normal mt-[16px] md:mt-[24px]"
              />
              <div className="mt-[16px] sm:mt-[80px] text-center">
                <ButtonNova
                  label={"Start Chat"}
                  icon={"Left"}
                  level={"Tertiary"}
                  onClick={launchZenDesk}
                  className="mx-auto"
                />
              </div>
            </ContactWrapper>
          </Box>
          <Box
            width={[1, null, 1 / 2]}
            mb={[24, null, null, 40]}
            px={[0, 0, 12, 20]}
          >
            <ContactWrapper className="bg-nova-base-solid-20 text-center p-[32px] md:p-[40px]">
              <TextElementNova
                element="h3"
                text={`We’re here for you.`}
                className="Subtitle-20-Dia-Normal"
              />
              <TextElementNova
                element="p"
                text={`More than a supplement subscription, we’re committed to supporting you as you grow.`}
                className="Body-20-Dia-Normal mt-[16px] md:mt-[24px] md:w-[330px] mx-auto"
              />
              <div className="mt-[16px] sm:mt-[80px] text-center">
                <ButtonNova
                  label={"More About Our Services"}
                  icon={"Left"}
                  level={"Tertiary"}
                  onClick={handleClickService}
                  className="mx-auto"
                />
              </div>
            </ContactWrapper>
          </Box>
          <Box width={[1, null, 1 / 2]} mb={[24, null, 0]} px={[0, 0, 12, 20]}>
            <ContactWrapperAlt className="pt-[16px] pb-[24px] sm:p-[40px] text-center">
              <TextElementNova
                element="p"
                text={`You can also text or call us at:`}
                className="Body-20-Dia-Normal mb-[8px] md:mb-[16px]"
              />
              <ButtonNova
                label={"(888) 454-3320"}
                level={"Textlink"}
                onClick={handleClickPhone}
                ctaLink={"tel:8884543320"}
                className="!inline-block"
              />
            </ContactWrapperAlt>
          </Box>
          <Box width={[1, null, 1 / 2]} px={[0, 0, 12, 20]}>
            <ContactWrapperAlt className="pt-[16px] pb-[24px] sm:p-[40px] text-center">
              <TextElementNova
                element="p"
                text={`Or reach us via email at:`}
                className="Body-20-Dia-Normal mb-[8px] md:mb-[16px]"
              />
              <ButtonNova
                label={"support@nutrafol.com"}
                level={"Textlink"}
                onClick={handleClickEmail}
                ctaLink={"mailto:support@nutrafol.com"}
                className="!inline-block"
              />
            </ContactWrapperAlt>
          </Box>
        </Flex>
      </Flex>
    </Section>
  )
}

export default FaqContact
